import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import week from 'dayjs/plugin/weekOfYear'
import React, { Component, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AuthProvider } from './context/AuthContext'
import { PrivateRoute } from './router/PrivateRoute'
import { PublicRoute } from './router/PublicRoute'
import './scss/style.scss'
dayjs.extend(week)
dayjs.extend(isBetween)
dayjs.extend(duration)

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const LoginByInstitution = React.lazy(() => import('./views/pages/login/LoginByInstitution'))

class App extends Component {
  render() {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'es'}>
        <AuthProvider>
          <BrowserRouter>
            <Suspense fallback={loading}>
              <Routes>
                <Route
                  path="public/*"
                  element={
                    <PublicRoute>
                      <Routes>
                        <Route exact path="/login" name="Login Page" element={<Login />} />
                        <Route
                          exact
                          path="/login/:name"
                          name="Login Page"
                          element={<LoginByInstitution />}
                        />
                      </Routes>
                    </PublicRoute>
                  }
                ></Route>
                <Route
                  path="/*"
                  element={
                    <PrivateRoute>
                      <Routes>
                        <Route path="*" name="Home" element={<DefaultLayout />} />
                      </Routes>
                    </PrivateRoute>
                  }
                ></Route>
              </Routes>
            </Suspense>
          </BrowserRouter>
          <ToastContainer position="top-right" autoClose={5000} />
        </AuthProvider>
      </LocalizationProvider>
    )
  }
}

export default App
